<template>
  <v-dialog v-model="modal" persistent max-width="1171">
    <v-card>
      <v-card-title v-if="this.discussionId" class="subheading">
        <span>
          <v-icon>mdi-account-multiple</v-icon>
          <b>Editar Discussão</b>
        </span>
      </v-card-title>
      <v-card-title v-else class="subheading">
        <span>
          <v-icon>mdi-account-multiple</v-icon>
          <b>Nova Discussão</b>
        </span>
      </v-card-title>
      <v-card-text class="text-center">
        <v-text-field
          v-model="form.title"
          :rules="[ v => !!v || 'O título é requerido' ]"
          label="Título"
          :error-messages="error.title"
          required/>
        <v-textarea outlined hide-details="auto" label="Descrição" v-if="modal" v-model="form.description" rows="6"></v-textarea>
      </v-card-text>
      <v-card-actions>
        <v-btn text @click.stop="cancel">Cancelar</v-btn>
        <v-spacer/>
        <v-btn color="secondary" text @click.stop="save">Salvar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { Forum } from '@/services/resources.js'

export default {
  props: {
    discussionId: {
      required: false
    },
    forumId: {
      required: true
    },
    topicId: {
      required: true
    }
  },
  data () {
    return {
      form: {
        title: '',
        status: 'E',
        description: ''
      },
      error: [],
      modal: false
    }
  },
  mounted () {
    if (this.discussionId) {
      Forum.getForumTopicDiscussion(this.discussionId)
        .then((response) => {
          this.form = { ...response.body.discussion }
        })
        .catch((error) => {
          console.log('responseError', error)
          this.$toasted.global.error({ message: error.statusText })
        })
    }

    this.modal = true
  },
  methods: {
    save () {
      this.form.forum_topic_id = this.topicId
      if (this.discussionId) {
        this.form._method = 'PATCH'
        Forum.updateDiscussionInForumTopic(this.form)
          .then((response) => {
            this.$toasted.global.success({ message: response.body.message })
          })
          .catch((error) => {
            console.log('responseError', error)
            this.error = error.body
            this.$toasted.global.error({ message: error.statusText })
          })
      } else {
        Forum.saveDiscussionInForumTopic(this.form)
          .then((response) => {
            this.form = {
              status: 'E',
              title: '',
              description: ''
            }

            this.model = false
            this.$toasted.global.success({ message: response.body.message })
            this.$router.push({ name: 'ambienteAluno.forum.topics.openTopic', params: { forumId: this.forumId, topicId: this.topicId } })
          })
          .catch((error) => {
            console.log('responseError', error)
            this.error = error.body
            this.$toasted.global.error({ message: error.statusText })
          })
      }
    },
    cancel () {
      this.form = {
        status: 'E',
        title: '',
        description: ''
      }

      this.model = false
      this.$router.back()
    }
  }
}
</script>
